// Dietary tag keys: keto, diabetic, gluten-free, nut-free

export const FILTERS = [
  { key: "keto", label: "Keto / Low-Carb" },
  { key: "diabetic", label: "Diabetic-Friendly" },
  { key: "gluten-free", label: "Gluten-Free" },
  { key: "nut-free", label: "Nut-Free" },
];

export const TAG_STYLES = {
  keto: { bg: "#F3F7F1", text: "#3E5334", label: "Keto" },
  diabetic: { bg: "#FDF5F0", text: "#A75429", label: "Diabetic-Friendly" },
  "gluten-free": { bg: "#F9F6EE", text: "#7C6A39", label: "Gluten-Free" },
  "nut-free": { bg: "#F4F6F8", text: "#3D5265", label: "Nut-Free" },
};

export const PRODUCTS = [
  {
    id: "banana-carrot-bread",
    name: "Banana Carrot Bread",
    image: "/products/banana-carrot-bread.jpg",
    blurb: "Moist, spiced loaf with real carrot & banana — zero refined sugar.",
    tags: ["diabetic", "nut-free"],
    netCarbs: "9g",
    sugar: "0g",
    ingredients: ["Ripe banana", "Fresh carrot", "Whole grain flour", "Maple syrup", "Cage-free eggs", "Cinnamon", "Vanilla"],
    prices: [
      { size: "Small", price: 2.5 },
      { size: "Medium", price: 4.5 },
      { size: "Large", price: 7.0 },
    ],
  },
  {
    id: "whole-wheat-banana-raisin",
    name: "Whole Wheat Banana Bread with Raisins",
    image: "https://images.unsplash.com/photo-1569762404472-026308ba6b64?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    blurb: "Hearty whole wheat loaf studded with naturally sweet raisins.",
    tags: ["diabetic", "nut-free"],
    netCarbs: "12g",
    sugar: "0g added",
    ingredients: ["Ripe banana", "Whole wheat flour", "Sun-dried raisins", "Honey", "Cage-free eggs", "Grass-fed butter", "Vanilla"],
    prices: [
      { size: "Small", price: 2.5 },
      { size: "Medium", price: 4.5 },
      { size: "Large", price: 7.0 },
    ],
  },
  {
    id: "chocolate-chip-banana-bread",
    name: "Chocolate Chip Banana Bread",
    image: "/products/chocolate-chip-banana-bread.jpg",
    blurb: "Rich banana loaf loaded with sugar-free dark chocolate chips.",
    tags: ["diabetic", "nut-free"],
    netCarbs: "11g",
    sugar: "0g added",
    ingredients: ["Ripe banana", "Whole grain flour", "Sugar-free dark chocolate chips", "Maple syrup", "Cage-free eggs", "Vanilla"],
    prices: [
      { size: "Small", price: 2.5 },
      { size: "Medium", price: 4.5 },
      { size: "Large", price: 7.0 },
    ],
  },
  {
    id: "peanut-butter-almond-cookies",
    name: "Peanut Butter Almond Cookies",
    image: "/products/peanut-butter-almond-cookies.jpg",
    blurb: "Buttery almond-flour cookies with real roasted peanut butter.",
    tags: ["keto", "diabetic", "gluten-free"],
    netCarbs: "3g",
    sugar: "0g",
    ingredients: ["Almond flour", "Natural peanut butter", "Maple syrup", "Cage-free eggs", "Sea salt", "Vanilla"],
    prices: [
      { size: "2-pack (3\")", price: 1.8 },
      { size: "Single (4\")", price: 3.0 },
      { size: "6-pack small", price: 4.8 },
      { size: "6-pack large", price: 8.0 },
    ],
  },
  {
    id: "oatmeal-raisin-cookies",
    name: "Oatmeal Raisin Cookies",
    image: "/products/oatmeal-raisin-cookies.jpg",
    blurb: "Classic chewy oatmeal cookies sweetened only with maple syrup.",
    tags: ["diabetic", "nut-free"],
    netCarbs: "10g",
    sugar: "0g added",
    ingredients: ["Rolled oats", "Whole grain flour", "Sun-dried raisins", "Maple syrup", "Grass-fed butter", "Cinnamon"],
    prices: [
      { size: "2-pack (3\")", price: 1.8 },
      { size: "Single (4\")", price: 2.0 },
    ],
  },
  {
    id: "chocolate-chip-cookies",
    name: "Chocolate Chip Cookies",
    image: "/products/chocolate-chip-cookies.jpg",
    blurb: "The nostalgic favorite — gooey chocolate, zero sugar guilt.",
    tags: ["diabetic", "nut-free"],
    netCarbs: "8g",
    sugar: "0g added",
    ingredients: ["Whole grain flour", "Sugar-free dark chocolate chips", "Honey", "Grass-fed butter", "Cage-free eggs", "Vanilla"],
    prices: [
      { size: "3-pack", price: 2.0 },
      { size: "6-pack", price: 4.0 },
    ],
  },
  {
    id: "almond-flour-raisin-cookies",
    name: "Almond Flour Raisin Cookies",
    image: "/products/almond-flour-raisin-cookies.jpg",
    blurb: "Grain-free almond cookies with plump, naturally sweet raisins.",
    tags: ["keto", "diabetic", "gluten-free"],
    netCarbs: "4g",
    sugar: "0g added",
    ingredients: ["Almond flour", "Sun-dried raisins", "Maple syrup", "Cage-free eggs", "Grass-fed butter", "Vanilla"],
    prices: [
      { size: "6-pack", price: 4.8 },
      { size: "12-pack", price: 8.0 },
    ],
  },
  {
    id: "almond-flour-chocolate-chip",
    name: "Almond Flour Chocolate Chip Cookies",
    image: "/products/almond-flour-chocolate-chip.jpg",
    blurb: "Keto-perfect almond cookies with melty sugar-free chocolate.",
    tags: ["keto", "diabetic", "gluten-free"],
    netCarbs: "3g",
    sugar: "0g",
    ingredients: ["Almond flour", "Sugar-free dark chocolate chips", "Maple syrup", "Cage-free eggs", "Grass-fed butter", "Sea salt"],
    prices: [
      { size: "6-pack", price: 4.8 },
      { size: "12-pack", price: 8.0 },
    ],
  },
];

export const FLAVORS = ["Banana Carrot Bread", "Whole Wheat Banana Bread with Raisins", "Chocolate Chip Banana Bread", "Peanut Butter Almond Cookies", "Oatmeal Raisin Cookies", "Chocolate Chip Cookies", "Almond Flour Raisin Cookies", "Almond Flour Chocolate Chip Cookies"];

// Price / quantity options per baked good (label shown in the dependent dropdown).
export const PRICING = {
  "Banana Carrot Bread": ["$2.50 · Small", "$4.50 · Medium", "$7.00 · Large"],
  "Whole Wheat Banana Bread with Raisins": ["$2.50 · Small", "$4.50 · Medium", "$7.00 · Large"],
  "Chocolate Chip Banana Bread": ["$2.50 · Small", "$4.50 · Medium", "$7.00 · Large"],
  "Peanut Butter Almond Cookies": ["$1.80 · 2-pack (3\")", "$3.00 · Single (4\")", "$4.80 · 6-pack small", "$8.00 · 6-pack large"],
  "Oatmeal Raisin Cookies": ["$1.80 · 2-pack (3\")", "$2.00 · Single (4\")"],
  "Chocolate Chip Cookies": ["$2.00 · 3-pack", "$4.00 · 6-pack"],
  "Almond Flour Raisin Cookies": ["$1.80 · 2-pack (3\")", "$3.00 · Single (4\")", "$4.80 · 6-pack small", "$8.00 · 6-pack large"],
  "Almond Flour Chocolate Chip Cookies": ["$4.80 · 6-pack", "$8.00 · 12-pack"],
};
export const FILLINGS = ["Sugar-Free Buttercream", "Cream Cheese Frosting", "Fresh Berry Compote", "Chocolate Ganache", "Lemon Curd", "None"];
